import { Spinner } from '@tallink/components-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'

import { getSummary } from '../../selectors/selectors'
import useFormatPrice from '../../utils/formatPrice'
import s from './LoadingPrice.module.scss'

export default function LoadingPrice({ price }) {
  const formatPrice = useFormatPrice()
  const { loading } = useSelector(getSummary)

  return loading ? (
    <div className={s.spinner}>
      <Spinner />
    </div>
  ) : (
    <div className={s['price-value']}>{formatPrice(price)}</div>
  )
}

LoadingPrice.propTypes = {
  price: PropTypes.number.isRequired
}
